<template>
    <div class="detail-row project-detail-contract-tab">
        <div class="detail-block">
            <div class="project-contract-list">
                <el-table class="ah-el-data-table" :data="value" key="contract" empty-text="無資料">
                    <el-table-column type="index" width="45"> </el-table-column>
                    <el-table-column prop="attachmenType" label="類型" width="80">
                        <template slot-scope="scope">
                            {{ getContractTypeLabel(scope.row.attachmenType) }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="paY_STS" label="檔案" width="300">
                        <template slot-scope="scope">
                            <ahFileItem :url="scope.row.attachment"></ahFileItem>
                        </template>
                    </el-table-column>
                    <el-table-column prop="note" label="備註"> </el-table-column>
                    <el-table-column prop="updateInfo" label="上傳人" width="130">
                        <template slot-scope="scope">
                            <div>{{ scope.row.updateUser }}</div>
                            <div>{{ scope.row.updateDate | dateFormater("YYYY-MM-dd") }}</div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="action" label="操作" width="80">
                        <template slot-scope="scope">
                            <el-dropdown v-if="isUploadable" trigger="click" @command="onImportCommand($event, scope.row)">
                                <span class="el-dropdown-link">
                                    <el-button size="small" icon="el-icon-more"></el-button>
                                </span>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item command="edit">編輯</el-dropdown-item>
                                    <el-dropdown-item command="delete">刪除</el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div v-if="isUploadable" class="upload-action">
                <el-button @click="onAddContract"> 上傳文件 </el-button>
            </div>
        </div>
        <ProjectContractEditDialog
            v-model="inputVal"
            :visible="projectContractEditDialog.visible"
            :project="project"
            :contract="projectContractEditDialog.contract"
            :sno="sno"
            @close="onProjectContractEditDialogClosed"
        />
    </div>
</template>

<script>
import _ from 'lodash';
import ahFileItem from '@/components/ui/ahFileItem.vue';
import ProjectContractEditDialog from '@/components/dashboard/Project/ProjectContractEditDialog.vue';
import { projectContractTypeOptions } from '@/assets/commonData/options';

export default {
    props: {
        value: {
            type: Array,
            default: () => [],
        },
        payoutTotal: {
            type: Number,
            default: 0,
        },
        sno: {
            type: Number,
            default: null,
        },
        project: {
            type: Object,
            default: () => {},
        },
    },
    components: { ahFileItem, ProjectContractEditDialog },
    computed: {
        inputVal: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            },
        },
        userSno() {
            return this.$store.getters['account/userSno'];
        },
        isUploadable() {
            return (
                this.isAuth('C04')
                || (this.isAuth('C01') && this.project.stF_SNO === this.userSno)
                || (this.isAuth('C01-1') && this.project.projectEmployeePermissions.find((o) => o.employeeSno === this.userSno)?.uploadDocument)
            );
        },
    },
    data() {
        return {
            projectContractEditDialog: {
                visible: false,
                sno: null,
            },
        };
    },
    methods: {
        onAddContract() {
            this.projectContractEditDialog.visible = true;
        },
        onEditContract(contract) {
            this.projectContractEditDialog.visible = true;
            this.projectContractEditDialog.contract = contract;
        },
        async onDeleteContract(row) {
            try {
                await this.$confirm('確定要刪除文件？', {
                    confirmButtonText: '確定',
                    cancelButtonText: '取消',
                });

                if (!this.sno) {
                    const FOUND = _.findIndex(this.inputVal, row);
                    this.inputVal.splice(FOUND, 1);
                    return;
                }

                await this.$api({
                    url: '/ProjectManagementPage/DeleteContractFile',
                    method: 'DELETE',
                    data: {
                        projectSno: this.project.sno,
                        sno: row.sno,
                    },
                });

                this.$message({
                    showClose: true,
                    message: '已刪除文件',
                    type: 'success',
                });

                this.$emit('refresh');
            } catch (e) {
                console.log(e);
            }
        },
        onProjectContractEditDialogClosed(refresh) {
            this.projectContractEditDialog.visible = false;
            this.projectContractEditDialog.contract = null;
            if (refresh) this.$emit('refresh');
        },
        async onImportCommand(cmd, row) {
            if (cmd === 'edit') this.onEditContract(row);
            else if (cmd === 'delete') this.onDeleteContract(row);
        },
        getContractTypeLabel(typ) {
            return projectContractTypeOptions.find((o) => o.value === typ).label;
        },
    },
};
</script>

<style lang="scss" scoped>
.upload-action {
    display: flex;
    margin-top: 20px;
}
</style>
